<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="ShiftMasterPoliciesForm" (ngSubmit)="Validate(ShiftMasterPoliciesForm)"
        #ShiftMasterPoliciesForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Detail
                </div>
                <div class="card-body">
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-4 align-self-center">
                                    <label for="AttendanceType" class="form-label text-label-dark">Attendance Type
                                        :</label>
                                </div>
                                <div class="col-md-5">
                                    <div class="btn-group btn-group-toggle">
                                        <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                            <input class="form-check-input" type="radio"
                                                (change)="AttendanceTypeChange()" value='hour' name="AttendanceType"
                                                [(ngModel)]="ShiftRuleDetail.AttendanceType"
                                                [ngModelOptions]="{standalone: true}">
                                            Hour
                                        </label>
                                        <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                            <input class="form-check-input" type="radio"
                                                (change)="AttendanceTypeChange()" value='time' name="AttendanceType"
                                                [(ngModel)]="ShiftRuleDetail.AttendanceType"
                                                [ngModelOptions]="{standalone: true}">
                                            Time
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-4 align-self-center">
                                    <label for="IsSinglePunchAllowed" class="form-label text-label-dark">Single Punch
                                        Allowed :</label>
                                </div>
                                <div class="col-md-5">
                                    <div class="btn-group btn-group-toggle">
                                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                            <input class="form-check-input" type="radio" [value]=true
                                                name='IsSinglePunchAllowed'
                                                [(ngModel)]="ShiftRuleDetail.IsSinglePunchAllowed"
                                                [ngModelOptions]="{standalone: true}">
                                            Yes
                                        </label>
                                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                            <input class="form-check-input" type="radio" [value]=false
                                                name='IsSinglePunchAllowed'
                                                [(ngModel)]="ShiftRuleDetail.IsSinglePunchAllowed"
                                                [ngModelOptions]="{standalone: true}">
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-4 align-self-center">
                                    <label class="form-label text-label-dark">Full Day Duration : </label>
                                </div>
                                <div class="col-md-auto">
                                    <ngb-timepicker name="Duration" type="time"
                                        [(ngModel)]="ShiftRuleDetail.DurationObj" #Duration="ngModel"
                                        (change)="timeFormate($event,'Duration')" [ngModelOptions]="{standalone: true}"
                                        required></ngb-timepicker>
                                    <div class="invalid-feedback">
                                        Please enter duration!
                                    </div>
                                </div>
                                <div class="col-md-auto align-self-center">
                                    <label class="form-label text-label-dark">hours</label>
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.Message24hr"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-4 align-self-center">
                                    <label class="form-label text-label-dark">Half Day Duration : </label>
                                </div>
                                <div class="col-md-auto">
                                    <ngb-timepicker name="HalfDayDuration" type="time"
                                        [(ngModel)]="ShiftRuleDetail.HalfDayDurationObj" #HalfDayDuration="ngModel"
                                        [ngModelOptions]="{standalone: true}"
                                        (change)="timeFormate($event,'HalfDayDuration')" required></ngb-timepicker>
                                    <div class="invalid-feedback">
                                        Please enter duration!
                                    </div>
                                </div>
                                <div class="col-md-auto align-self-center">
                                    <label class="form-label text-label-dark">hours</label>
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.Message24hr"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="card mb-1">
                                <div class="card-header">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" name="IsGraceApplicable"
                                            id="IsGraceApplicable" [(ngModel)]="ShiftRuleDetail.IsGraceApplicable"
                                            [disabled]="ShiftRuleDetail.AttendanceType != 'time'">
                                        <label class="form-check-label" for="IsGraceApplicable">
                                            Grace Period
                                        </label>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-2">
                                        <div class="col-md-6 align-self-center">
                                            <input class="form-check-input me-1" type="checkbox"
                                                name="FirstCheckInLateApplicable" id="FirstCheckInLateApplicable"
                                                [(ngModel)]="ShiftRuleDetail.FirstCheckInLateApplicable"
                                                [disabled]="!ShiftRuleDetail.IsGraceApplicable">
                                            <label for="FirstCheckInLateApplicable" class="form-label text-label-dark"
                                                style="padding-right: 18px;">First
                                                check-in late
                                                by : </label>
                                        </div>
                                        <div class="col-md-auto">
                                            <ngb-timepicker name="FirstCheckInLate" type="time"
                                                [(ngModel)]="ShiftRuleDetail.FirstCheckInLateObj"
                                                #FirstCheckInLate="ngModel" [ngModelOptions]="{standalone: true}"
                                                [disabled]="ShiftRuleDetail.AttendanceType != 'time' || !ShiftRuleDetail.IsGraceApplicable || !ShiftRuleDetail.FirstCheckInLateApplicable"
                                                required></ngb-timepicker>

                                            <div class="invalid-feedback">
                                                Please enter first check in late!
                                            </div>
                                        </div>
                                        <div class="col-md-auto align-self-center">
                                            <label class="form-label text-label-dark">hours</label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.Message24hr"></i>
                                        </div>
                                    </div>
                                    <div class="row mb-6">
                                        <div class="col-md-6 align-self-center">
                                            <input class="form-check-input me-1" type="checkbox"
                                                name="LastCheckOutEarlyApplicable" id="LastCheckOutEarlyApplicable"
                                                [(ngModel)]="ShiftRuleDetail.LastCheckOutEarlyApplicable"
                                                [disabled]="!ShiftRuleDetail.IsGraceApplicable">
                                            <label for="LastCheckOutEarlyApplicable"
                                                class="form-label text-label-dark">Late check-out early by : </label>
                                        </div>
                                        <div class="col-md-auto">
                                            <ngb-timepicker name="LastCheckOutEarly" type="time"
                                                [(ngModel)]="ShiftRuleDetail.LastCheckOutEarlyObj"
                                                #LastCheckOutEarly="ngModel" [ngModelOptions]="{standalone: true}"
                                                [disabled]="ShiftRuleDetail.AttendanceType != 'time' || !ShiftRuleDetail.IsGraceApplicable || !ShiftRuleDetail.LastCheckOutEarlyApplicable"
                                                required></ngb-timepicker>
                                            <div class="invalid-feedback">
                                                Please enter last check out early!
                                            </div>
                                        </div>
                                        <div class="col-md-auto align-self-center">
                                            <label class="form-label text-label-dark">hours</label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.Message24hr"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card mb-1">
                                <div class="card-header">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" name="ShiftMargin"
                                            id="ShiftMargin" [(ngModel)]="ShiftRuleDetail.ShiftMargin">
                                        <label class="form-check-label" for="ShiftMargin">
                                            Shift Margin
                                        </label>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-2">
                                        <div class="col-md-6 align-self-center">
                                            <input class="form-check-input me-1" type="checkbox"
                                                name="Hoursbeforetheshiftstart" id="Hoursbeforetheshiftstart"
                                                [(ngModel)]="ShiftRuleDetail.HourBeforeShiftStartApplicable"
                                                [disabled]="!ShiftRuleDetail.ShiftMargin">
                                            <label for="Hoursbeforetheshiftstart"
                                                class="form-label text-label-dark">Hours before the shift start :
                                            </label>
                                        </div>
                                        <div class="col-md-auto">
                                            <ngb-timepicker name="HourBeforeShiftStart" type="time"
                                                [(ngModel)]="ShiftRuleDetail.HourBeforeShiftStartObj"
                                                #HourBeforeShiftStart="ngModel" [ngModelOptions]="{standalone: true}"
                                                [disabled]="!ShiftRuleDetail.ShiftMargin || !ShiftRuleDetail.HourBeforeShiftStartApplicable"
                                                required></ngb-timepicker>
                                            <div class="invalid-feedback">
                                                Please enter hour before shift start!
                                            </div>
                                        </div>
                                        <div class="col-md-auto align-self-center text-label-dark">
                                            <label class="form-label">hours</label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.Message24hr"></i>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-6 align-self-center">
                                            <input class="form-check-input me-1" type="checkbox"
                                                name="HourAfterShiftStartApplicable" id="HourAfterShiftStartApplicable"
                                                [(ngModel)]="ShiftRuleDetail.HourAfterShiftStartApplicable"
                                                [disabled]="!ShiftRuleDetail.ShiftMargin">
                                            <label for="HourAfterShiftStartApplicable"
                                                class="form-label text-label-dark">Hours after the shift start :
                                            </label>
                                        </div>
                                        <div class="col-md-auto">
                                            <ngb-timepicker name="HourAfterShiftStart" type="time"
                                                [(ngModel)]="ShiftRuleDetail.HourAfterShiftStartObj"
                                                #HourAfterShiftStart="ngModel" [ngModelOptions]="{standalone: true}"
                                                [disabled]="!ShiftRuleDetail.ShiftMargin  || !ShiftRuleDetail.HourAfterShiftStartApplicable"
                                                required></ngb-timepicker>

                                            <div class="invalid-feedback">
                                                Please enter hour after shift start!
                                            </div>
                                        </div>
                                        <div class="col-md-auto align-self-center">
                                            <label class="form-label text-label-dark">hours</label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.Message24hr"></i>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-6 align-self-center">
                                            <input class="form-check-input me-1" type="checkbox"
                                                name="HourAfterShiftEndApplicable" id="HourAfterShiftEndApplicable"
                                                [(ngModel)]="ShiftRuleDetail.HourAfterShiftEndApplicable"
                                                [disabled]="!ShiftRuleDetail.ShiftMargin">
                                            <label for="HourAfterShiftEndApplicable"
                                                class="form-label text-label-dark">Hour After Shift End :
                                            </label>
                                        </div>
                                        <div class="col-md-auto">
                                            <ngb-timepicker name="HourAfterShiftEnd" type="time"
                                                [(ngModel)]="ShiftRuleDetail.HourAfterShiftEndObj"
                                                #HourAfterShiftEnd="ngModel" [ngModelOptions]="{standalone: true}"
                                                [disabled]="!ShiftRuleDetail.ShiftMargin  || !ShiftRuleDetail.HourAfterShiftEndApplicable"
                                                required></ngb-timepicker>

                                            <div class="invalid-feedback">
                                                Please enter hour after shift end!
                                            </div>
                                        </div>
                                        <div class="col-md-auto align-self-center">
                                            <label class="form-label text-label-dark">hours</label>
                                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                                [ngbTooltip]="tooltip.Message24hr"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>